"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.last = exports.rest = exports.tail = exports.first = exports.head = exports.isSeq = void 0;

// simple utils for working with sequences like Array or string
var isSeq = function isSeq(seq) {
  return typeof seq === 'string' || Array.isArray(seq);
};

exports.isSeq = isSeq;

var head = function head(seq) {
  return isSeq(seq) ? seq[0] : null;
};

exports.head = head;
var first = head;
exports.first = first;

var tail = function tail(seq) {
  return isSeq(seq) ? seq.slice(1) : null;
};

exports.tail = tail;
var rest = tail;
exports.rest = rest;

var last = function last(seq) {
  return isSeq(seq) ? seq[seq.length - 1] : null;
};

exports.last = last;